import React from 'react';
import Styled from 'styled-components';
import { Container, Flex } from '@components/layout/Grid';
import { ProgramCategory } from '@gql/generated';

const appearanceColors = {
  [ProgramCategory['Programs']]: {
    primary: '#119EDD',
    secondary: '#667C91',
    neutral: '#243240',
  },
  // sam as programs for now
  [ProgramCategory['Healthcare']]: {
    primary: '#119EDD',
    secondary: '#667C91',
    neutral: '#243240',
  },
  [ProgramCategory['Courses']]: {
    primary: '#119EDD',
    secondary: '#667C91',
    neutral: '#243240',
  },
  [ProgramCategory['Challenges']]: {
    primary: '#32847E',
    secondary: '#A1BCBA',
    neutral: '#213E3D',
  },
};

const Bar = Styled(Container)<{ appearance?: ProgramCategory }>`
  display: none;
  
  @media(min-width: ${({ theme }) => theme.viewports.tablet}px){
    display: block;
    height: 42px;
  }
`;

const Items = Styled(Flex)<{ appearance?: ProgramCategory }>`
  height: 100%;
  border-bottom: 2px solid ${({ appearance }) =>
    appearanceColors[appearance].secondary};
`;

const ProgramPart = Styled.button<{
  isActive?: boolean;
  appearance?: ProgramCategory;
}>`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 14px;
  color: ${({ isActive, appearance }) =>
    isActive
      ? appearanceColors[appearance].primary
      : appearanceColors[appearance].neutral};
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 500)};
  border: none;
  padding-bottom: 20px;
  margin: 0;
  background: none;
  cursor: pointer;

  :after {
    content: "\\e923";
    position: absolute;
    bottom: 0;
    left: 50%;
    font-family: 'ygb-font';
    display: block;
    font-size: 16px;
    color: ${({ isActive, appearance }) =>
      isActive
        ? appearanceColors[appearance].primary
        : appearanceColors[appearance].secondary};
    transform: translate(-50%, calc(50% + 1px));
  }
`;

type Props = {
  activeSection: number;
  sections: Array<{ title: React.ReactNode; id: string }>;
  onItemClick(index: number): void;
  programCategory?: ProgramCategory;
};

const ProgramPartsBar = (props: Props) => {
  const {
    activeSection,
    sections = [],
    onItemClick,
    programCategory = ProgramCategory['Programs'],
  } = props;

  if (sections?.length < 4) {
    return null;
  }

  return (
    <Bar
      flexDirection="column"
      data-testid="ProgramSectionsBar"
      px={[20, 20, 10]}
      mt="30px"
      mb="20px"
    >
      <Items appearance={programCategory}>
        {sections.map((item, index) => {
          return item ? (
            <ProgramPart
              key={item.id}
              isActive={index === activeSection}
              onClick={() => onItemClick(index)}
              appearance={programCategory}
            >
              {item.title}
            </ProgramPart>
          ) : null;
        })}
      </Items>
    </Bar>
  );
};

export default ProgramPartsBar;
